import { Box, Card, Grid, Toolbar, IconButton } from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import { CardButton } from '../../components/buttons'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../context'

const AdminPage = () => {
    const navigate = useNavigate()
    const { isSuperAdmin } = useUser()

    const adminItems = [
        { variant: 'users' },
        { variant: 'roles', superAdminOnly: true },
        { variant: 'patterns' },
        { variant: 'news' },
        { variant: 'machinesAdmin' },
        { variant: 'dispositivos', superAdminOnly: true },
        { variant: 'gallery', superAdminOnly: true },
        { variant: 'admin-crons-sync', superAdminOnly: true },
        { variant: 'admin-manuals', superAdminOnly: true },
    ]

    const visibleItems = adminItems.filter(item => !item.superAdminOnly || isSuperAdmin)

    return (
        <Box height='100%'>
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'}>
                        <Grid container alignItems='center' justifyContent='center'>
                            <div style={{ width: '100%', textAlign: 'left', padding: 10 }}>
                                <div style={{ width: '100%', textAlign: 'left', color: '#333', backgroundColor: '#fff', borderRadius: 20 }}>
                                    <Toolbar style={{ paddingLeft: 0, backgroundColor: '#F9F9F9', borderRadius: 10 }}>
                                        <IconButton onClick={() => setTimeout(() => {
                                            navigate(-1)
                                        }, 500)}>
                                            <ArrowBackIos style={{ color: '#333', fontSize: 16 }}/>
                                        </IconButton>
                                        <h1 style={{ marginTop: 0, marginBottom: 0, fontSize: 16 }}>
                                            Administración
                                        </h1>
                                    </Toolbar>
                                </div>
                            </div>
                        </Grid>

                        <Box 
                            sx={{ 
                                display: 'flex', 
                                flexWrap: 'wrap', 
                                justifyContent: 'center', 
                                alignItems: 'stretch',
                                gap: isSuperAdmin ? { xs: 1, sm: 1.2, md: 1.5 } : 2, 
                                p: isSuperAdmin ? 1.5 : 2,
                                width: '100%'
                            }}
                        >
                            {visibleItems.map((item) => (
                                <Box
                                    key={item.variant}
                                    sx={{
                                        flex: isSuperAdmin 
                                            ? { xs: '1 1 calc(50% - 12px)', sm: '1 1 calc(33.33% - 12px)', md: '1 1 calc(20% - 12px)', lg: '1 1 0px' } 
                                            : { xs: '1 1 calc(50% - 16px)', sm: '1 1 calc(25% - 16px)', md: '1 1 200px' },
                                        minWidth: isSuperAdmin ? { xs: 130, sm: 120, md: 100, lg: 0 } : 180,
                                        maxWidth: isSuperAdmin ? { lg: 'calc(100% / 9 - 12px)', xl: '220px' } : 260,
                                        display: 'flex',
                                        alignItems: 'stretch'
                                    }}
                                >
                                    <CardButton 
                                        variant={item.variant} 
                                        sx={isSuperAdmin ? {
                                            margin: 0,
                                            minHeight: { xs: 150, sm: 170, md: 200, lg: 220 },
                                            padding: { xs: 1, md: 1.5 },
                                            '& .icon': { padding: { xs: 1, md: 1.5 } },
                                            '& .iconButton': { fontSize: { xs: '2.2rem', sm: '2.5rem', md: '3rem', lg: '3.2rem' } },
                                            '& .button-font-size': { fontSize: { xs: '0.72rem', sm: '0.78rem', md: '0.85rem' } }
                                        } : { margin: 0 }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AdminPage